import React from 'react';
import PropTypes from 'prop-types';
import { getSourceValue } from '../../lib/common';
import { useAuth } from '../../contexts/auth';
import { handleImpressionsTrack } from '../../api';

function BannerRedirection({ projectId, faqId, faqObj }) {
  const source = getSourceValue();
  const [authState] = useAuth();
  const { selectedBusiness } = authState;
  const getBannerType = sessionStorage.getItem('bannerType');

  const handleBannerRedirection = async () => {
    if (projectId === 'csportal') {
      const bannerType = getBannerType === 'Web Banner' ? 'webbanner' : 'mobilebanner';
      const liVal = 'click';
      const liTrd = `cta_clickhere`;
      const faqTypeVal = '';
      const othersData = [];
      const llTrd = `issue_${bannerType}`;
      const llTrdInside = `faq_${faqObj?.faqKey}`;
      await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState, llTrdInside);
    }
    if (faqId === 21 || faqId === 22) {
      window.location.href = `https://wap.justdial.com/analytics/adsresponse?el=0&nh=0&rootvc=0&docid=${selectedBusiness?.docid}&source=${source}&tab=adsresponse&version=0&tab=adsresponse`;
    } else {
      window.location.href = `https://www.justdial.com/BNR-${
        selectedBusiness?.shorturl || ''
      }?hide_header=1&support=1&source=${source}`;
    }
  };
  return (
    <div className="pl-10 pr-10">
      {faqId === 21 || faqId === 22 ? null : (
        <div className="font12 clr777">
          We don&#39;t find rotational web banner campaign signed by you. Get to know features &amp; benefits of banner
          product.
        </div>
      )}

      {projectId === 'csportal' && (
        <a
          tabIndex={0}
          role="button"
          onKeyDown={() => {}}
          onClick={() => handleBannerRedirection()}
          type="button"
          className="banner_redirection_button font14 fw500"
        >
          Click Here
        </a>
      )}
    </div>
  );
}

export default BannerRedirection;

BannerRedirection.propTypes = {
  projectId: PropTypes.string,
  faqId: PropTypes.number,
  faqObj: PropTypes.object,
};
